import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { getBackLink } from '@core/jss-routing';

@Component({
  selector: 'wl-back-button-sidebar',
  templateUrl: './back-button-sidebar.component.html',
})
export class BackButtonSidebarComponent {
  backLink$ = this.store$.pipe(select(getBackLink));

  constructor(private readonly store$: Store<any>) {}
}
